import { UserCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useIsConnected } from "@/hooks/useContactConnections";

interface ConnectedBadgeProps {
  contactId?: string | null;
  size?: "sm" | "md";
  className?: string;
  iconOnly?: boolean;
}

export function ConnectedBadge({
  contactId,
  size = "sm",
  className,
  iconOnly = false,
}: ConnectedBadgeProps) {
  const { connected, entry } = useIsConnected(contactId);
  if (!connected || !entry) return null;

  const tooltipText = [
    `Connected via ${entry.sender_name || "a rep"}`,
    entry.connected_at ? `on ${new Date(entry.connected_at).toLocaleDateString()}` : null,
    entry.source ? `Source: ${entry.source}` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            className={cn(
              "border-blue-300 bg-blue-50 text-blue-800 hover:bg-blue-100",
              size === "sm" ? "h-5 px-1.5 text-[10px]" : "h-6 px-2 text-xs",
              className,
            )}
          >
            <UserCheck className={cn(size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5", iconOnly ? "" : "mr-1")} />
            {!iconOnly && (entry.sender_name?.split(" ")[0] || "Connected")}
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{tooltipText}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
